'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$24() {
  this.bg4 = null;
  this.bg2 = null;
  this.bg3 = false;
  this.bg0 = null;
  this.bg1 = false;
  this.bg5 = false;
  this.bg6 = false;
  this.bg4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$24 as $c_Lpresto_PrestoRouter$$anon$24 };
$p = $c_Lpresto_PrestoRouter$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$24;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$24() {
}
export { $h_Lpresto_PrestoRouter$$anon$24 as $h_Lpresto_PrestoRouter$$anon$24 };
$h_Lpresto_PrestoRouter$$anon$24.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bg4;
});
$p.t = (function() {
  if ((!this.bg3)) {
    this.bg2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bg3 = true;
  }
  return this.bg2;
});
$p.ae = (function() {
  if ((!this.bg1)) {
    this.bg0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bg1 = true;
  }
  return this.bg0;
});
$p.w = (function() {
  if ((!this.bg6)) {
    this.bg5 = false;
    this.bg6 = true;
  }
  return this.bg5;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$24, "presto.PrestoRouter$$anon$24", ({
  NO: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$24 as $d_Lpresto_PrestoRouter$$anon$24 };
//# sourceMappingURL=presto.-Presto-Router$$anon$24.js.map
